import { localStorage } from 'dibs-browser-storage';
import { isAbTestVariant, getAbTestTrackingData } from '../../utils/abTest/clientABTestHelpers';
import tracking from 'dibs-tracking';

const SUSPECTED_TRADE_ACQUISITION_VIEWS = 'SUSPECTED_TRADE_ACQUISITION_VIEWS';
const HAS_SEEN_SUSPECTED_TRADE_ACQUISITION = 'HAS_SEEN_SUSPECTED_TRADE_ACQUISITION';
const SUSPECTED_TRADE_ACQUISITION_DISMISSED = 'SUSPECTED_TRADE_ACQUISITION_DISMISSED';
const SUSPECTED_TRADE_ACQUISITION_MAX_VIEWS = 10;

export const TRADE_WINDFALL_REFERRAL_KEY = 'windfall';

function getViewCount() {
    return localStorage.getItem(SUSPECTED_TRADE_ACQUISITION_VIEWS) || 0;
}

function logFirstView() {
    if (getViewCount() === 1) {
        localStorage.setItem(HAS_SEEN_SUSPECTED_TRADE_ACQUISITION, true);
    }
}

export function logView() {
    localStorage.setItem(SUSPECTED_TRADE_ACQUISITION_VIEWS, getViewCount() + 1);
    logFirstView();
}

function maxViewsCountExceeded() {
    return getViewCount() >= SUSPECTED_TRADE_ACQUISITION_MAX_VIEWS;
}

export function showSuspectedTradeUserAcquisition() {
    return !maxViewsCountExceeded();
}

export function setAcquisitionDismissed() {
    localStorage.setItem(SUSPECTED_TRADE_ACQUISITION_DISMISSED, true);
}

export function isAcquisitionDismissed() {
    return localStorage.getItem(SUSPECTED_TRADE_ACQUISITION_DISMISSED);
}

const SUSPECTED_TRADE_CONSUMERS_TEST_NAME = 'SUSPECTED_TRADE_CONSUMERS';

export function showSuspectedTradeTest() {
    return isAbTestVariant(document.cookie, SUSPECTED_TRADE_CONSUMERS_TEST_NAME);
}

export function trackSuspectedTradeTest(pageType) {
    const trackingData = getAbTestTrackingData(
        document.cookie,
        SUSPECTED_TRADE_CONSUMERS_TEST_NAME
    );
    tracking.trackAbTestEvent(trackingData, pageType);
}
